var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    (_vm.isNotMainDomain && !_vm.isLocalHost && _vm.show && _vm.warningMessage) ||
      (_vm.isLocalHost && _vm.isProductionApi && _vm.show && _vm.warningMessage) ||
      _vm.showAlways
  )?_c('div',{class:{ 'text-header-6' : _vm.isAdmin },attrs:{"id":"footer-notes-by-domain"},domProps:{"innerHTML":_vm._s(_vm.warningMessage)},on:{"click":function($event){_vm.show = false}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }